import { INDEPENDENT_SYMBOL_2079, PROPORTIONAL_SEAT, PR_THERESHOLD_PERCENT, SHORT_NAMES, toBeExcludedParties, TOP_PARTY_COUNT, TRANSLATIONS } from "../config";

export const getDistrictSummary = (districtData) => {
  if (districtData.length === 0) {
    const summary = {
      id: 0,
      win: [{ party: "O", win: 0 }],
      lead: [{ party: "O", lead: 0 }],
      totalWin: 0,
      totalLead: 0,
      ern: 0,
    };

    return summary;
  }

  const declaredRegions = (districtData && districtData.regions.filter((rdata) => rdata.declared && Object.keys(rdata.elected).length > 0)) || [];

  let districtWinCount = [];
  declaredRegions.forEach((region) => {
    let existParty = districtWinCount.find((w) => w.party === region.elected.party);
    if (existParty) {
      existParty.win += 1;
    } else {
      const newParty = { party: region.elected.party, win: 1 };
      districtWinCount.push(newParty);
    }
  });

  districtWinCount = districtWinCount.sort((a, b) => b.win - a.win);
  // const topWinParties = districtWinCount.filter((a, i) => i < TOP_PARTY_COUNT - 1);
  // const winOthers = districtWinCount.filter((a, i) => i >= TOP_PARTY_COUNT - 1);
  // const winOther = { party: "O", win: winOthers.reduce((a, b) => a + b.win, 0) };
  // districtWinCount = [...topWinParties, winOther];

  const countingRegions = (districtData && districtData.regions.filter((rdata) => !rdata.declared)) || [];

  let districtLeadCount = [];
  let followingCandidates = [];
  countingRegions.forEach((region) => {
    if (!region.result || region.result.length === 0) return true;
    const sortedResult = region.result.sort((a, b) => b.vote - a.vote);

    // 1st leading party
    const leadingCandidate = sortedResult[0];

    // append following parties
    for (let n = 1; n <= TOP_PARTY_COUNT; n++) {
      if (sortedResult.length > n) followingCandidates.push(sortedResult[n]);
    }

    // find already appended party in the array
    let existParty = districtLeadCount.find((w) => w.party === leadingCandidate.party);
    if (existParty && leadingCandidate.vote > 0) {
      existParty.lead += 1;
    } else if (leadingCandidate.vote > 0) {
      const newParty = { party: leadingCandidate.party, lead: 1 };
      districtLeadCount.push(newParty);
    } else if (!existParty) {
      const newParty = { party: leadingCandidate.party, lead: 0 };
      districtLeadCount.push(newParty);
    }
  });

  if (countingRegions.length === 0 && districtData) {
    districtData.regions
      .filter((rdata) => rdata.declared)
      .forEach((dr) =>
        dr.result
          .filter((drf) => !drf.elected)
          .forEach((c) => {
            followingCandidates.push(c);
          })
      );
  }

  districtLeadCount = districtLeadCount.sort((a, b) => b.lead - a.lead);
  // const topLeadParties = districtLeadCount.filter((a, i) => i < TOP_PARTY_COUNT - 1);
  // const leadOthers = districtLeadCount.filter((a, i) => i >= TOP_PARTY_COUNT - 1);
  // const leadOther = { party: "O", lead: leadOthers.reduce((a, b) => a + b.lead, 0) };
  // districtLeadCount = [...topLeadParties, leadOther];

  for (let i = districtLeadCount.length, j = 0; i < TOP_PARTY_COUNT; i++, j++) {
    if (j < districtWinCount.length && !districtLeadCount.map((lc) => lc.party).includes(districtWinCount[j].party)) {
      const lead = districtWinCount[j];
      districtLeadCount.push({ party: lead.party, lead: 0 });
    } else {
      const lp = districtLeadCount.map((lc) => lc.party);
      const nextPartyCandidate = followingCandidates.find((fc) => !lp.includes(fc.party));
      if (nextPartyCandidate) {
        districtLeadCount.push({ party: nextPartyCandidate.party, lead: 0 });
      }
    }
  }

  for (let i = districtWinCount.length, j = 0; i < TOP_PARTY_COUNT; i++, j++) {
    if (j < districtLeadCount.length && !districtWinCount.map((lc) => lc.party).includes(districtLeadCount[j].party)) {
      const lead = districtLeadCount[j];
      districtWinCount.push({ party: lead.party, win: 0 });
    } else {
      const wp = districtWinCount.map((wc) => wc.party);
      const nextPartyCandidate = followingCandidates.find((fc) => !wp.includes(fc.party));
      if (nextPartyCandidate) {
        districtWinCount.push({ party: nextPartyCandidate.party, win: 0 });
      }
    }
  }

  let others = districtWinCount.find((a) => a.party === "O");

  districtWinCount = districtWinCount
    .filter((f) => f.party !== "O")
    .sort((a, b) => {
      if (a.party !== "O") return b.win - a.win;
      else return false;
    });

  if (others) {
    districtWinCount.push(others);
  }

  others = districtLeadCount.find((a) => a.party === "O");

  districtLeadCount = districtLeadCount
    .filter((f) => f.party !== "O")
    .sort((a, b) => {
      if (a.party !== "O") return b.lead - a.lead;
      else return false;
    });

  if (others) {
    districtLeadCount.push(others);
  }

  const totalWin = districtWinCount.reduce((a, b) => a + b.win, 0);
  const totalLead = districtLeadCount.reduce((a, b) => a + b.lead, 0);

  let ern = 0;
  districtData.regions.forEach(() => {
    ern++;
  });

  const summary = {
    id: districtData.id,
    win: districtWinCount,
    lead: districtLeadCount,
    totalWin,
    totalLead,
    ern,
  };

  return summary;
};

export const getProvinceSummary = (provinceData, all) => {
  if (provinceData.length === 0) {
    const summary = {
      id: 0,
      win: [{ party: "O", win: 0 }],
      lead: [{ party: "O", lead: 0 }],
      totalWin: 0,
      totalLead: 0,
      ern: 0,
    };

    return summary;
  }

  const partyCount = all ? 30 : TOP_PARTY_COUNT;
  let declaredRegions = [];
  provinceData.districts.forEach((dData) => {
    const declaredTemp = dData.regions.filter((rdata) => rdata.declared && Object.keys(rdata.elected).length > 0);
    if (declaredTemp.length > 0) {
      declaredRegions = declaredRegions.concat(declaredTemp);
    }
  });

  let provinceWinCount = [];
  declaredRegions.forEach((region) => {
    let existParty = provinceWinCount.find((w) => w.party === region.elected.party);
    if (existParty) {
      existParty.win += 1;
    } else {
      const newParty = { party: region.elected.party, win: 1 };
      provinceWinCount.push(newParty);
    }
  });

  provinceWinCount = provinceWinCount.sort((a, b) => b.win - a.win);
  const topWinParties = provinceWinCount.filter((a, i) => i < partyCount - 1);
  const winOthers = provinceWinCount.filter((a, i) => i >= partyCount - 1);
  const winOther = { party: "O", win: winOthers.reduce((a, b) => a + b.win, 0) };
  provinceWinCount = [...topWinParties, winOther];

  let countingRegions = [];
  provinceData.districts.forEach((dData) => {
    const countingTemp = dData.regions.filter((rdata) => !rdata.declared);
    if (countingTemp.length > 0) {
      countingRegions = countingRegions.concat(countingTemp);
    }
  });

  let provinceLeadCount = [];
  let followingCandidates = [];

  countingRegions.forEach((region) => {
    if (!region.result || region.result.length === 0) return true;
    const sortedResult = region.result.sort((a, b) => b.vote - a.vote);

    // 1st leading party
    const leadingCandidate = sortedResult[0];

    // append following parties
    for (let n = 1; n <= partyCount; n++) {
      if (sortedResult.length > n) followingCandidates.push(sortedResult[n]);
    }

    let existParty = provinceLeadCount.find((w) => w.party === leadingCandidate.party);

    if (existParty && leadingCandidate.vote > 0) {
      existParty.lead += 1;
    } else if (leadingCandidate.vote > 0) {
      const newParty = { party: leadingCandidate.party, lead: 1 };
      provinceLeadCount.push(newParty);
    } else if (!existParty) {
      const newParty = { party: leadingCandidate.party, lead: 0 };
      provinceLeadCount.push(newParty);
    }
  });

  provinceLeadCount = provinceLeadCount.sort((a, b) => b.lead - a.lead);
  const topLeadParties = provinceLeadCount.filter((a, i) => i < partyCount - 1);
  const leadOthers = provinceLeadCount.filter((a, i) => i >= partyCount - 1);
  const leadOther = { party: "O", lead: leadOthers.reduce((a, b) => a + b.lead, 0) };
  provinceLeadCount = [...topLeadParties, leadOther];

  for (let i = provinceLeadCount.length, j = 0; i < partyCount; i++, j++) {
    if (j < provinceWinCount.length && !provinceLeadCount.map((lc) => lc.party).includes(provinceWinCount[j].party)) {
      const lead = provinceWinCount[j];
      provinceLeadCount.push({ party: lead.party, lead: 0 });
    } else {
      const lp = provinceLeadCount.map((lc) => lc.party);
      const nextPartyCandidate = followingCandidates.find((fc) => !lp.includes(fc.party));
      if (nextPartyCandidate) {
        provinceLeadCount.push({ party: nextPartyCandidate.party, lead: 0 });
      }
    }
  }

  provinceWinCount = provinceWinCount.sort((a, b) => b.win - a.win);
  provinceLeadCount = provinceLeadCount.sort((a, b) => b.lead - a.lead);

  for (let i = provinceWinCount.length, j = 0; i < partyCount; i++, j++) {
    if (j < provinceLeadCount.length && !provinceWinCount.map((lc) => lc.party).includes(provinceLeadCount[j].party)) {
      const lead = provinceLeadCount[j];
      provinceWinCount.push({ party: lead.party, win: 0 });
    } else {
      const wp = provinceWinCount.map((wc) => wc.party);
      const nextPartyCandidate = followingCandidates.find((fc) => !wp.includes(fc.party));
      if (nextPartyCandidate) {
        provinceWinCount.push({ party: nextPartyCandidate.party, win: 0 });
      }
    }
  }

  let ern = 0;
  provinceData.districts.forEach((d) => {
    d.regions.forEach(() => {
      ern++;
    });
  });

  let others = provinceWinCount.find((a) => a.party === "O");

  provinceWinCount = provinceWinCount
    .filter((f) => f.party !== "O")
    .sort((a, b) => {
      if (a.party !== "O") return b.win - a.win;
      else return false;
    });

  if (others) {
    provinceWinCount.push(others);
  }

  others = provinceLeadCount.find((a) => a.party === "O");

  provinceLeadCount = provinceLeadCount
    .filter((f) => f.party !== "O")
    .sort((a, b) => {
      if (a.party !== "O") return b.lead - a.lead;
      else return false;
    });

  if (others) {
    provinceLeadCount.push(others);
  }

  const totalWin = provinceWinCount.reduce((a, b) => a + b.win, 0);
  const totalLead = provinceLeadCount.reduce((a, b) => a + b.lead, 0);

  const summary = {
    id: provinceData.id,
    win: provinceWinCount,
    lead: provinceLeadCount,
    totalWin,
    totalLead,
    ern,
  };

  return summary;
};

export const getGlobalSummary = (globalData, all) => {
  const partyCount = all ? 30 : TOP_PARTY_COUNT;
  if (globalData.provinces.length === 0) {
    const summary = {
      win: [{ party: "O", win: 0 }],
      lead: [{ party: "O", lead: 0 }],
      totalWin: 0,
      totalLead: 0,
      ern: 0,
    };

    return summary;
  }
  let declaredRegions = [];
  globalData.provinces.forEach((pData) => {
    pData.districts.forEach((dData) => {
      const declaredTemp = dData.regions.filter((rdata) => rdata.declared && Object.keys(rdata.elected).length > 0);
      if (declaredTemp.length > 0) {
        declaredRegions = declaredRegions.concat(declaredTemp);
      }
    });
  });

  let globalWinCount = [];
  declaredRegions.forEach((region) => {
    let existParty = globalWinCount.find((w) => w.party === region.elected.party && Object.keys(region.elected).length > 0);
    if (existParty) {
      existParty.win += 1;
    } else {
      const newParty = { party: region.elected.party, win: 1 };
      globalWinCount.push(newParty);
    }
  });

  globalWinCount = globalWinCount.sort((a, b) => b.win - a.win);
  const topWinParties = globalWinCount.filter((a, i) => i < partyCount - 1);
  const winOthers = globalWinCount.filter((a, i) => i >= partyCount - 1);
  const winOther = { party: "O", win: winOthers.reduce((a, b) => a + b.win, 0) };
  globalWinCount = [...topWinParties, winOther];

  let countingRegions = [];
  globalData.provinces.forEach((pData) => {
    pData.districts.forEach((dData) => {
      const countingTemp = dData.regions.filter((rdata) => !rdata.declared);
      if (countingTemp.length > 0) {
        countingRegions = countingRegions.concat(countingTemp);
      }
    });
  });

  let globalLeadCount = [];
  let followingCandidates = [];
  countingRegions.forEach((region) => {
    if (!region.result || region.result.length === 0) return true;
    const sortedResult = region.result.sort((a, b) => b.vote - a.vote);

    // 1st leading party
    const leadingCandidate = sortedResult[0];

    // append following parties
    for (let n = 1; n <= partyCount; n++) {
      if (sortedResult.length > n) followingCandidates.push(sortedResult[n]);
    }

    // find already appended party in the array
    let existParty = globalLeadCount.find((w) => w.party === leadingCandidate.party);
    if (existParty && leadingCandidate.vote > 0) {
      existParty.lead += 1;
    } else if (leadingCandidate.vote > 0) {
      const newParty = { party: leadingCandidate.party, lead: 1 };
      globalLeadCount.push(newParty);
    } else if (!existParty) {
      const newParty = { party: leadingCandidate.party, lead: 0 };
      globalLeadCount.push(newParty);
    }
  });

  globalLeadCount = globalLeadCount.sort((a, b) => b.lead - a.lead);
  const topLeadParties = globalLeadCount.filter((a, i) => i < partyCount - 1);
  const leadOthers = globalLeadCount.filter((a, i) => i >= partyCount - 1);
  const leadOther = { party: "O", lead: leadOthers.reduce((a, b) => a + b.lead, 0) };
  globalLeadCount = [...topLeadParties, leadOther];

  for (let i = globalLeadCount.length, j = 0; i < partyCount; i++, j++) {
    if (j < globalWinCount.length && !globalLeadCount.map((lc) => lc.party).includes(globalWinCount[j].party)) {
      const lead = globalWinCount[j];
      globalLeadCount.push({ party: lead.party, lead: 0 });
    } else {
      const lp = globalLeadCount.map((lc) => lc.party);
      const nextPartyCandidate = followingCandidates.find((fc) => !lp.includes(fc.party));
      if (nextPartyCandidate) {
        globalLeadCount.push({ party: nextPartyCandidate.party, lead: 0 });
      }
    }
  }

  globalWinCount = globalWinCount.sort((a, b) => b.win - a.win);
  globalLeadCount = globalLeadCount.sort((a, b) => b.lead - a.lead);

  for (let i = globalWinCount.length, j = 0; i < partyCount; i++, j++) {
    if (j < globalLeadCount.length && !globalWinCount.map((lc) => lc.party).includes(globalLeadCount[j].party)) {
      const lead = globalLeadCount[j];
      globalWinCount.push({ party: lead.party, win: 0 });
    } else {
      const wp = globalWinCount.map((wc) => wc.party);
      const nextPartyCandidate = followingCandidates.find((fc) => !wp.includes(fc.party));
      if (nextPartyCandidate) {
        globalWinCount.push({ party: nextPartyCandidate.party, win: 0 });
      }
    }
  }

  let ern = 0;
  globalData.provinces.forEach((p) => {
    p.districts.forEach((d) => {
      d.regions.forEach(() => {
        ern++;
      });
    });
  });

  let others = globalWinCount.find((a) => a.party === "O");

  globalWinCount = globalWinCount
    .filter((f) => f.party !== "O")
    .sort((a, b) => {
      if (a.party !== "O") return b.win - a.win;
      else return false;
    });

  if (others) {
    globalWinCount.push(others);
  }

  others = globalLeadCount.find((a) => a.party === "O");

  globalLeadCount = globalLeadCount
    .filter((f) => f.party !== "O")
    .sort((a, b) => {
      if (a.party !== "O") return b.lead - a.lead;
      else return false;
    });

  if (others) {
    globalLeadCount.push(others);
  }

  const totalWin = globalWinCount.reduce((a, b) => a + b.win, 0);
  const totalLead = globalLeadCount.reduce((a, b) => a + b.lead, 0);

  const summary = {
    win: globalWinCount,
    lead: globalLeadCount,
    totalWin,
    totalLead,
    ern,
  };

  return summary;
};

export const getDistrictPath = (pid, did) => {
  const urlParams = new URLSearchParams(window.location.search);
  let base_url = "/result/";
  let type = urlParams.get("type");
  let lang = urlParams.get("lang") || "np";

  const url = base_url + pid + "/" + did + (type ? "?type=" + type + "&lang=" + lang : "?lang=" + lang);

  return url;
};

export const getRegionPath = (pid, did, rid) => {
  const urlParams = new URLSearchParams(window.location.search);
  let base_url = "/result/";
  let type = urlParams.get("type");
  let lang = urlParams.get("lang") || "np";

  const url = base_url + pid + "/" + did + "/" + rid + (type ? "?type=" + type + "&lang=" + lang : "?lang=" + lang);

  return url;
};

export const getPercentage = (val, total) => {
  if (total === 0) {
    return "0%";
  }
  let result = (val / parseFloat(total)) * 100;
  result = result.toFixed(0) + "%";
  return result;
};

export const translatePercentage = (val, total, lang) => {
  if (total === 0) {
    return translateNumber("0%", lang);
  }
  let result = (val / parseFloat(total)) * 100;
  result = result.toFixed(0) + "%";
  return translateNumber(result, lang);
};

export const translate = (key, lang) => {
  if (!key) return "";
  if (!TRANSLATIONS[key]) {
    let words = key.split("_");
    let result = "";
    for (let i = 0; i < words.length; i++) {
      result += words[i].replace(words[i][0], words[i][0].toUpperCase()) + " ";
    }
    return result.trim();
  } else if (!lang) {
    return TRANSLATIONS[key]["en"];
  } else {
    return TRANSLATIONS[key][lang];
  }
};

export const translateNumber = (num, lang) => {
  num = !num ? "0" : num;
  num = num.toString();
  let commaNum = "";

  if (num.includes(".") || num.includes("%") || num.includes("-")) {
    commaNum = num;
  } else {
    num = num.split("").reverse().join("");
    for (let i = num.length - 1; i >= 0; i--) {
      if (i === 2 || i === 4 || i === 6) {
        commaNum += ",";
      }
      commaNum += num[i];
    }

    commaNum = commaNum.replace(/(^,)|(,$)/g, "");
  }

  if (lang === "en") {
    if (commaNum.endsWith(".1")) {
      commaNum = parseFloat(commaNum).toFixed(1).replace(".1", "(A)");
    } else if (commaNum.endsWith(".2")) {
      commaNum = parseFloat(commaNum).toFixed(1).replace(".2", "(B)");
    }

    return commaNum;
  }

  if (commaNum.endsWith(".1")) {
    commaNum = parseFloat(commaNum).toFixed(1).replace(".1", "(क)");
  } else if (commaNum.endsWith(".2")) {
    commaNum = parseFloat(commaNum).toFixed(1).replace(".2", "(ख)");
  }
  commaNum = commaNum.replace(/0/g, "०");
  commaNum = commaNum.replace(/1/g, "१");
  commaNum = commaNum.replace(/2/g, "२");
  commaNum = commaNum.replace(/3/g, "३");
  commaNum = commaNum.replace(/4/g, "४");
  commaNum = commaNum.replace(/5/g, "५");
  commaNum = commaNum.replace(/6/g, "६");
  commaNum = commaNum.replace(/7/g, "७");
  commaNum = commaNum.replace(/8/g, "८");
  commaNum = commaNum.replace(/9/g, "९");
  return commaNum;
};

export const getShortName = (key) => {
  const notFound = { name_np: key.replace(key[0], key[0].toUpperCase()), name_en: key.replace(key[0], key[0].toUpperCase()) };
  return SHORT_NAMES[key] || notFound;
};

export const getAge = (birthdate) => {
  const today = new Date();
  const birthday = new Date(birthdate);
  const diffTimeMili = today - birthday;
  const diffDay = Math.ceil(diffTimeMili / (1000 * 60 * 60 * 24 * 365));
  return diffDay;
};

export const getTimeAgo = (updatedDate) => {
  let date = new Date();
  let now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  date = new Date(updatedDate);
  updatedDate = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  const diffSec = parseInt((now_utc - updatedDate) / 1000);
  const year = parseInt(diffSec / (60 * 60 * 24 * 365));
  const month = parseInt(diffSec / (60 * 60 * 24 * 30));
  const week = parseInt(diffSec / (60 * 60 * 24 * 7));
  const day = parseInt(diffSec / (60 * 60 * 24));
  const hr = parseInt(diffSec / (60 * 60));
  const min = parseInt(diffSec / 60);

  if (year > 0 && diffSec > 60) {
    return {
      time: year,
      metrics: year > 1 ? "years" : "year",
    };
  } else if (month > 0) {
    return {
      time: month,
      metrics: month > 1 ? "months" : "month",
    };
  } else if (week > 0) {
    return {
      time: week,
      metrics: week > 1 ? "weeks" : "week",
    };
  } else if (day > 0) {
    return {
      time: day,
      metrics: day > 1 ? "days" : "day",
    };
  } else if (hr > 0) {
    return {
      time: hr,
      metrics: hr > 1 ? "hours" : "hour",
    };
  } else if (min > 0) {
    return {
      time: min,
      metrics: min > 1 ? "minutes" : "minute",
    };
  } else {
    return {
      time: diffSec,
      metrics: diffSec > 1 ? "seconds" : "second",
    };
  }
};

export const groupBy = (list, keyGetter) => {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
};

export const getIndependentSymbol = (did, rid, name) => {
  const symbolFound = INDEPENDENT_SYMBOL_2079.find((a) => a.candidates.includes(did + "_" + rid + "_" + name.toLowerCase().replaceAll(" ", "_")));
  const symbol = symbolFound ? symbolFound.symbol : "O";
  return symbol;
};

export const getProportionalSeat = (pr_result_data, provinceId) => {
  const grandTotal = pr_result_data.filter((x) => !toBeExcludedParties.includes(x.party)).reduce((a, b) => a + b.vote, 0);
  const threshold = parseInt(grandTotal * PR_THERESHOLD_PERCENT[provinceId]);

  const pr_results = JSON.parse(JSON.stringify(pr_result_data.filter((pr) => !toBeExcludedParties.includes(pr.party)).filter((x, i) => i < 10)));
  const totalVote = pr_results.reduce((a, b) => a + b.vote, 0);
  let nationalParties = pr_results.filter((x) => x.vote > threshold);

  /********* Straight Forward Formula (Proportion Rule) *********/
  if (false) {
    const totalNational = nationalParties.reduce((a, b) => a + b.vote, 0);
    const oneSeat = parseInt(totalNational / PROPORTIONAL_SEAT[provinceId]);

    nationalParties = nationalParties.map((np) => {
      np.seat = parseInt(Math.floor(np.vote / oneSeat, 0));
      return np;
    });
  }
  /********* Straight Forward Formula (Proportion Rule) *********/

  /********* Webster/Sainte-Laguë method *********/
  // let n = 1;
  let sparty = {};
  nationalParties.forEach((p) => {
    sparty[p.party] = 0;
  });

  while (1) {
    let lq = 0;
    let party = "";
    for (let j = 0; j < nationalParties.length; j++) {
      let q = nationalParties[j].vote / (2 * sparty[nationalParties[j].party] + 1);
      if (lq < q) {
        lq = q;
        party = nationalParties[j].party;
      }
    }
    sparty[party] += 1;
    // n += 2;
    let total = 0;
    for (let v in sparty) {
      total = total + sparty[v];
    }

    if (total === PROPORTIONAL_SEAT[provinceId]) {
      break;
    }
  }
  /********* Webster/Sainte-Laguë method *********/

  /* Now allowcate the seat as per algorithm */
  nationalParties = nationalParties.map((np) => {
    np.seat = sparty[np.party];
    return np;
  });

  return { nationalParties, grandTotal, pr_results, totalVote };
};
